import styled from 'styled-components';

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledHeaderTitle = styled.div`
  font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
  font-size: ${(props) => (props.smallFontSize ? '18px':  props.isMobileResolution?'20px' : '32px')};
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  align-self: center;
  margin-left: ${(props) => (props.showIcon ? '12px' : '0')};
`;
